// Configuration Module
// ----------------------------

// Here we export configuration objects (constants) for
// API enpoints, routes URL, analytics, whatever.

// __API_HOST__ and similars are "magic" environment variables, see webpack/config.js

export { API } from './api.config';
export { ROLES } from './roles.config';
export { PLANS } from './plans.config';
export { PROVINCES } from './provinces.config';
export { CONSTANTS } from './constants.config';



// WEBPACK FOOTER //
// ./src/config/index.js